import Color from "color";

export default function UserCell({
  name,
  color,
}: {
  name?: string | null;
  color?: string | null;
}) {
  const initials = name?.[0];

  const safeColor = color && color !== "null" ? color : "#DCE4E9";
  const colorObj = Color(safeColor);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "8px",
      }}
    >
      <div
        style={{
          background: colorObj.alpha(0.2).toString(),
          color: colorObj.darken(0.5).toString(),
          width: "26px",
          height: "26px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          fontSize: "13px",
          fontWeight: 600,
        }}
      >
        {initials}
      </div>
      <span
        style={{
          fontSize: "13px",
          fontWeight: 400,
        }}
      >
        {name}
      </span>
    </div>
  );
}
